import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCMotherDuck extends NPC {
    constructor() {
        super(definitions.NPC_ID.MOTHER_DUCK);

        this.collisionRadius = 6;
        this.collisionOffsetX = 2;
        this.collisionOffsetY = -16;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_mother_duck_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.8, new PIXI.Point(3, -4));
        this.animateIdle(0.35);
    }
}